<template>
  <div class="bc-tooltip-balloon-container flex rounded-lg bg-dark/40 p-2 text-absoluteWhite">
    <slot />
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.bc-tooltip-balloon-container{
  backdrop-filter: blur(8px);
  box-shadow: 0 0 1px 0 #A0A8C0 inset, 0 4px 8px 0 rgba(0, 0, 0, 0.20);
}
</style>